import { useEffect } from 'react';
import { getEnvironment } from '@/services/platform.service';

export function ConfirmScript(props) {
  const { cost, appointmentId } = props;
  const environment = getEnvironment();

  const productId =
    environment === 'production' ? 'appointment booking' : 'non-prod booking';
  useEffect(() => {
    // GA4: fire pay_landing only after Square has confirmed payment and the
    // appointment record exists. This component only mounts on the confirm
    // step, so the event tracks true completed payments (not "Continue" clicks).
    if (typeof window.gtag === 'function' && appointmentId) {
      try {
        window.gtag('event', 'pay_landing', {
          currency: 'USD',
          value: Number(cost),
          transaction_id: appointmentId,
        });
      } catch (err) {
        console.error('GA4 pay_landing event failed:', err);
      }
    }

    // Need this check for PostAffTracker because ad blockers will stop the global script from running, and cause errors on appointment booking
    /*global PostAffTracker*/
    if (PostAffTracker) {
      PostAffTracker.setAccountId('default1');
      var sale = PostAffTracker.createSale();
      sale.setTotalCost(cost);
      sale.setOrderID(appointmentId);
      sale.setProductID(productId);
      PostAffTracker.register();
    }
  }, [appointmentId]);
  return <></>;
}
